import { whenRequestsSettled } from './request-cache';

// Start werk dat niet nodig is voor de eerste weergave pas nadat de pagina
// geladen is én de eerste reeks API-requests klaar is. Op een koude server
// wacht elke extra gelijktijdige request op een nieuw PHP-proces; zo krijgen
// de boeken voorrang. maxWait garandeert dat het werk hoe dan ook start.
export function afterStartup(task, maxWait = 6000) {
    let started = false;
    const run = () => {
        if (started) return;
        started = true;
        try {
            task();
        } catch (error) {
            // achtergrondwerk mag de app nooit breken
        }
    };

    const idle = (fn) => (typeof window.requestIdleCallback === 'function'
        ? window.requestIdleCallback(fn, { timeout: 1000 })
        : window.setTimeout(fn, 0));

    const begin = () => {
        whenRequestsSettled().then(() => idle(run));
        window.setTimeout(run, maxWait);
    };

    if (typeof window === 'undefined' || typeof document === 'undefined') {
        run();
    } else if (document.readyState === 'complete') {
        begin();
    } else {
        window.addEventListener('load', begin, { once: true });
    }
}
